
import {BsFillHouseFill, BsPencilSquare, BsPeople, BsBoxSeamFill, BsBoxes, BsFillPlusCircleFill, BsFillCupHotFill, BsGrid1X2Fill, BsBell  } from 'react-icons/bs';
import { FaHandshake } from "react-icons/fa6";
import { FiCheckSquare, FiLock } from 'react-icons/fi';

const zc = [
    {
        name:'Requests',
        link:'zc/home',
        icon:<BsPencilSquare size={20}/>
    },
    {
        name:'Zone Suppliers',
        link:'zc/home/zoneSuppliers',
        icon:<BsPeople size={20}/>
    },
    {
        name:'Stock',
        link:'zc/stock',
        icon:<BsBoxes size={20}/>
    }
]

const central_zc = [
    {
        name:'Requests',
        link:'zc/home',
        icon:<BsPencilSquare size={20}/>
    },{
        name:'Supply Requests',
        link:'central/supplyapproval',
        icon:<BsPeople size={20}/>
    },
    {
        name:'Stock',
        link:'zc/stock',
        icon:<BsBoxes size={20}/>
    },
    {
        name:'Miqaats',
        link:'zc/view-miqaats',
        icon:<BsBell size={20}/>
    },
    {
        name:'Zone Suppliers',
        link:'zc/home/zoneSuppliers',
        icon:<BsPeople size={20}/>
    },
]

// Used by Purchase, Admin, CityAdmin — Silat is SuperAdmin-only
const central = [
    {
        name:'Home',
        link:'central/home',
        icon:<BsFillHouseFill size={20}/>
    },
    {
        name:'Suppliers',
        link:'central/suppliers',
        icon:<BsPeople size={20}/>
    },
    {
        name:'Dishes',
        link:'central/dishes',
        icon:<BsFillCupHotFill size={20}/>
    },
    {
        name:'Menus',
        link:'central/menu',
        icon:<BsGrid1X2Fill size={20}/>
    },
    {
        name:'Purchase Orders',
        link:'central/po',
        icon:<BsFillPlusCircleFill size={20}/>
    },
    {
        name:'Items',
        link:'central/items',
        icon:<BsBoxSeamFill size={20}/>
    },
    {
        name:'Reports',
        link:'reports',
        icon:<BsBoxSeamFill size={20}/>
    },
]

const supplier = [
    {
        name:'Home',
        link:'supplier/home',
        icon:<BsFillHouseFill size={20}/>
    },
    {
        name:'Items',
        link:'supplier/items',
        icon:<BsBoxSeamFill size={20}/>
    }
]

const umaal = [
    {
        name:'Home',
        link:'silat/home',
        icon:<BsFillHouseFill size={20}/>
    },
    {
        name:'My Silat Commitments',
        link:'/silat/commitments/edit/:id',
        icon:<BsBoxSeamFill size={20}/>
    },
    {
        name:'My Zabihat Commitments',
        link:'/silat/commitments/zabihat/edit/:id',
        icon:<BsBoxSeamFill size={20}/>
    }
]

// SuperAdmin on their dashboard (not inside a city) — master catalog + Silat
const superadmin = [
    {
        name: 'Cities',
        link: '/superadmin/home',
        icon: <BsFillHouseFill size={20}/>
    },
    {
        name: 'Items',
        link: 'central/items',
        icon: <BsBoxSeamFill size={20}/>
    },
    {
        name: 'Dishes',
        link: 'central/dishes',
        icon: <BsFillCupHotFill size={20}/>
    },
    {
        name: 'Menus',
        link: 'central/menu',
        icon: <BsGrid1X2Fill size={20}/>
    },
    {
        name: 'Silat',
        link: 'silat/home',
        icon: <FaHandshake size={20}/>
    },
    {
        name: 'Silat Commitments',
        link: 'silat/commitments',
        icon: <FiCheckSquare size={20}/>
    },
    {
        name: 'Change Password',
        link: '/superadmin/change-password',
        icon: <FiLock size={20}/>
    },
]

// SuperAdmin inside a city — full city nav + Silat
const superadminCity = [
    ...central,
    {
        name: 'Silat',
        link: 'silat/home',
        icon: <FaHandshake size={20}/>
    },
    {
        name: 'Silat Commitments',
        link: 'silat/commitments',
        icon: <FiCheckSquare size={20}/>
    },
    {
        name: 'Change Password',
        link: '/superadmin/change-password',
        icon: <FiLock size={20}/>
    },
]

export {
    zc, central, supplier, central_zc, umaal, superadmin, superadminCity
}
